import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
    Text,
    Flex,
    Textarea,
    Divider,
    Box,
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
} from "@chakra-ui/react";
import { useTaxesV2 } from "../../../hooks/useTaxsV2";
import { HistoryIcon } from "../../../styles/icons/HistoryIcon";
import { NoteIcon } from "../../../styles/icons/NoteIcon";
import { RightArrow } from "../../../styles/icons/RightArrow";
import { reverseAdjustNewResponse, transformPaymentData } from "../utils/functions";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SectionReviewModal } from "./_SectionReview";
import { SectionCreditCardReviewModal } from "./_sectionCreditCard";
import { useEffect, useState } from "react";


const textObsertaionSchema = yup.object().shape({
    observation: yup.string().required("Por favor, inclua uma observação sobre o motivo da alteração de valores"),
});


interface reviewModalProps {
    creditCardNewRates: any;
    creditCardOldRates: any;
    organizateRateReviewPixNew: any;
    organizateRateReviewPixOld: any;
    organizateRateReviewBankSlipOld: any;
    organizateRateReviewBankSlipNew: any;
    organizateRateReviewCreditCardOld: any;
    organizateRateReviewCreditCardNew: any;
    isHistory: any;
    organizateRateNew: any;
    organizateRateOld: any;
    observationText: any;
    setObservationText: any;
    setUpdatePage?: any;
    setResetTrigger?: any;
    resetTrigger?: any;
    createdDate?: string;
}

export function ReviewModal({
    creditCardNewRates,
    creditCardOldRates,
    organizateRateReviewPixNew,
    organizateRateReviewPixOld,
    organizateRateReviewBankSlipOld,
    organizateRateReviewBankSlipNew,
    organizateRateReviewCreditCardOld,
    organizateRateReviewCreditCardNew,
    isHistory,
    organizateRateNew,
    organizateRateOld,
    observationText,
    setObservationText,
    setResetTrigger,
    createdDate,

}: reviewModalProps) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const PREDEFINED_ORIGINS = ["ONLINE", "POS", "TAP_TO_PAY"];
    const { updateSellerRates, } = useTaxesV2();
    const { email } = JSON.parse(localStorage.getItem("barte-user-info"))
    const [currentTime, setCurrentTime] = useState(new Date());
    const [Loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    const formattedDate = currentTime.toLocaleDateString("pt-BR");
    const formattedTime = currentTime.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });


    const {
        watch, setValue, handleSubmit,
        formState: { errors }, control,
    } = useForm({
        resolver: yupResolver(textObsertaionSchema),
        mode: 'onBlur',
    });
    const observation = watch("observation")



    // const paymentRatesList = [
    //     {
    //         "paymentMethod": 2,
    //         "paymentBrand": null,
    //         "paymentOrigin": 7,
    //         "repaymentDay": 1,
    //         "seller": 1,
    //         "rateType": "DEFAULT_BARTE",
    //         "rates": [
    //             {
    //                 "installments": 1,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 2,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 3,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 4,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 5,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 6,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 7,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 8,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 9,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {

    //                 "installments": 10,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 11,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 12,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 13,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 14,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 15,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 16,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 17,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 18,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 19,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 20,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 21,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 22,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 23,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 24,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             }
    //         ]
    //     },
    //     {
    //         "paymentMethod": 3,
    //         "paymentBrand": null,
    //         "paymentOrigin": 7,
    //         "repaymentDay": 1,
    //         "seller": 1,
    //         "rateType": "DEFAULT_BARTE",
    //         "rates": [
    //             {
    //                 "installments": 1,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 2,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 3,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 4,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 5,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 6,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 7,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 8,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 9,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 10,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 11,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 12,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 13,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 14,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 15,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 16,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 17,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 18,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 19,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 20,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 21,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 22,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 23,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             },
    //             {
    //                 "installments": 24,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": 10
    //             }
    //         ]
    //     },
    //     {
    //         "paymentMethod": 5,
    //         "paymentBrand": null,
    //         "paymentOrigin": 4,
    //         "repaymentDay": 1,
    //         "seller": 1,
    //         "rateType": "DEFAULT_BARTE",
    //         "rates": [
    //             {
    //                 "installments": 1,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 2,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 7.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 3,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 8.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 4,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 9,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 5,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 9.59,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 6,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 10.2,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 7,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 10.7,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 8,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 11.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 9,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 12.8,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 10,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 14.95,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 11,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 15.2,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 12,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 15.9,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 13,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 17.58,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 14,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 18.64,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 15,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 19.7,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 16,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 20.78,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 17,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 21.87,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 18,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 22.97,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 19,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.08,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 20,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.11,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 21,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.74,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 22,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 25.31,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 23,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 25.84,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 24,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 26.38,
    //                 "rateLimitValue": null
    //             }
    //         ]
    //     },
    //     {
    //         "paymentMethod": 5,
    //         "paymentBrand": null,
    //         "paymentOrigin": 3,
    //         "repaymentDay": 1,
    //         "seller": 1,
    //         "rateType": "DEFAULT_BARTE",
    //         "rates": [
    //             {
    //                 "installments": 1,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 2,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 7.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 3,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 8.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 4,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 9,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 5,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 9.59,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 6,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 10.2,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 7,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 10.7,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 8,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 11.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 9,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 12.8,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 10,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 14.95,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 11,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 15.2,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 12,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 15.9,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 13,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 17.58,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 14,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 18.64,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 15,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 19.7,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 16,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 20.78,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 17,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 21.87,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 18,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 22.97,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 19,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.08,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 20,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.11,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 21,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.74,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 22,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 25.31,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 23,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 25.84,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 24,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 26.38,
    //                 "rateLimitValue": null
    //             }
    //         ]
    //     },
    //     {
    //         "paymentMethod": 5,
    //         "paymentBrand": null,
    //         "paymentOrigin": 6,
    //         "repaymentDay": 1,
    //         "seller": 1,
    //         "rateType": "DEFAULT_BARTE",
    //         "rates": [
    //             {
    //                 "installments": 1,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 4.79,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 2,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 7.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 3,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 8.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 4,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 9,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 5,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 9.59,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 6,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 10.2,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 7,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 10.7,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 8,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 11.3,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 9,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 12.8,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 10,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 14.95,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 11,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 15.2,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 12,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 15.9,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 13,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 17.58,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 14,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 18.64,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 15,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 19.7,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 16,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 20.78,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 17,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 21.87,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 18,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 22.97,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 19,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.08,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 20,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.11,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 21,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 24.74,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 22,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 25.31,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 23,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 25.84,
    //                 "rateLimitValue": null
    //             },
    //             {
    //                 "installments": 24,
    //                 "paymentFeeType": "PERCENTAGE",
    //                 "paymentFeeValue": 26.38,
    //                 "rateLimitValue": null
    //             }
    //         ]
    //     }
    // ]



    useEffect(() => {
        if (observation !== observationText) {
            setValue("observation", observationText)
        }
        // eslint-disable-next-line
    }, [observationText])




    const onSubmit = async () => {
        setLoading(true)
        const paymentRatesList = transformPaymentData(reverseAdjustNewResponse(organizateRateNew))
        if (paymentRatesList) {
            try {

                const response = await updateSellerRates({ description: observationText, paymentRatesList })
                if (response.status >= 200 && response.status < 300) {
                    window.location.reload()
                }
            } catch (error) {
                console.log(error)
            } finally {
                onClose();
                setLoading(false)
            }

        }
    }





    function getTabs(name) {
        if (name === "ONLINE") {
            return "Online"
        }
        if (name === "TAP_TO_PAY") {
            return "Tap"
        }
        if (name === "POS") {
            return "POS"
        }
        if (name === "GLOBAL") {
            return "GLOBAL"
        }
    }

    const renderComparisonTables = () => {
        const allBrands = Array.from(new Set([
            ...Object.keys(creditCardOldRates || {}),
            ...Object.keys(creditCardNewRates || {})
        ]));
        return allBrands.map((brand) => {
            const newRates = creditCardNewRates?.[brand] || {};
            const oldRates = creditCardOldRates?.[brand] || {};
            const maxInstallments = 24;

            return (


                <Box key={brand} border="1px solid rgba(232, 232, 232, 1)" mb="6">
                    <Flex
                        justifyContent="center"
                        alignItems="center"
                        h="32px"
                        w="100%"
                        borderBottom="1px solid rgba(232, 232, 232, 1)"
                    >
                        <Text
                            fontSize="14px"
                            fontWeight="400"
                            fontFamily="Hero New"
                            lineHeight="22px"
                            textAlign="center"
                        >
                            {brand}
                        </Text>
                    </Flex>
                    <Table size="6xl" w="100%">
                        <Thead>
                            <Tr>
                                <Th w="40px" minW="40px"></Th>
                                {PREDEFINED_ORIGINS.map((origin) => (
                                    <Th
                                        key={origin}
                                        w="calc((100% - 40px) / 3)"
                                        textAlign="center"
                                        textTransform="none"
                                    >
                                        <Text
                                            fontSize="14px"
                                            fontWeight="400"
                                            fontFamily="Hero New"
                                            lineHeight="22px"
                                        >
                                            {getTabs(origin)}
                                        </Text>
                                    </Th>
                                ))}
                            </Tr>
                        </Thead>
                        <Tbody>
                            {Array.from({ length: maxInstallments }, (_, index) => index + 1).map((installment) => (
                                <Tr
                                    border="1px solid rgba(232, 232, 232, 1)"
                                    key={installment}
                                >
                                    <Td w="40px" textAlign="center">
                                        <Text
                                            color="rgba(195, 202, 215, 1)"
                                        >

                                            {installment}
                                        </Text>
                                    </Td>
                                    {PREDEFINED_ORIGINS.map((origin) => {
                                        const oldValue = oldRates?.[origin]?.find((item) => item?.installment === installment)?.value ?? "-";
                                        const newValue = newRates?.[origin]?.find((item) => item?.installment === installment)?.value ?? "-";


                                        return (
                                            <Td
                                                key={origin}
                                                w="30%"
                                                border="1px solid rgba(232, 232, 232, 1)"
                                                textAlign="center"
                                            >
                                                {(oldValue && newValue) ? (
                                                    <Flex
                                                        p="5px 10px"
                                                    >
                                                        {oldValue !== newValue ? (
                                                            <Flex
                                                                gap="10px"
                                                                alignItems="center"
                                                            >
                                                                <Text
                                                                    fontWeight="400"
                                                                    color="#000000"
                                                                >
                                                                    {oldValue}
                                                                </Text>
                                                                <RightArrow />
                                                                <Text
                                                                    fontWeight="bold"
                                                                    color="rgba(212, 136, 6, 1)"
                                                                >
                                                                    {newValue}
                                                                </Text>
                                                            </Flex>
                                                        ) : (
                                                            <Text
                                                                fontWeight="bold"
                                                                color="rgba(195, 202, 215, 1)"
                                                            >
                                                                {oldValue}
                                                            </Text>
                                                        )}
                                                    </Flex>
                                                ) : (
                                                    oldValue || newValue || "-"
                                                )}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </Box>
            );
        });
    };


    return (
        <Flex >
            {isHistory ?
                <Flex
                    onClick={onOpen}

                    gap="10px">
                    <HistoryIcon />
                    <Text
                        color="rgba(24, 144, 255, 1)"
                        fontSize="12px"
                        fontFamily="Hero New"
                        fontWeight="500"
                        cursor="pointer"
                    >

                        Ver alterações
                    </Text>
                </Flex>
                :


                <Button
                    onClick={onOpen}
                    colorScheme="blue"
                    w="87px"
                    h="32px"
                    borderRadius="2px"
                >
                    <Text
                        fontSize="14px"
                        fontFamily="Hero New"
                        fontWeight="400"
                    >

                        Concluir
                    </Text>
                </Button>
            }



            <Modal
                isOpen={isOpen} onClose={onClose} isCentered
                size={"6xl"}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Revise as alterações</ModalHeader>
                    <ModalCloseButton
                        variant="outline"
                    />
                    <ModalBody
                        overflowY="auto"
                        maxH="calc(100vh - 200px)"
                    >
                        <Flex flexDirection="column" gap="32px">
                            <Flex
                                flexDirection="column"
                                gap="24px"
                            >
                                <Flex gap="8px" alignItems="center">
                                    <NoteIcon />
                                    <Text
                                        fontSize="20px"
                                        fontFamily="Hero New"
                                        fontWeight="600"
                                        color="rgba(0, 0, 0, 1)"
                                    >
                                        Observações
                                    </Text>
                                </Flex>
                                <Flex flexDirection="column" w="100%"
                                >

                                    {isHistory === true ?
                                        <Text
                                            as="span"
                                            m="10px 0 -25px 17px"
                                            fontSize="12px"
                                            fontFamily='Hero New'
                                            fontWeight="bold"
                                            color="rgba(138, 148, 168, 1)"

                                        >

                                            {createdDate}
                                        </Text> :

                                        <Text
                                            as="span"
                                            m="10px 0 -25px 17px"
                                            fontSize="12px"
                                            fontFamily='Hero New'
                                            fontWeight="bold"
                                            color="rgba(138, 148, 168, 1)"

                                        >

                                            {formattedDate} - {formattedTime} - {email}
                                        </Text>

                                    }
                                    <Controller
                                        name="observation"
                                        control={control}
                                        defaultValue={observationText}
                                        render={({ field }) => (
                                            <Textarea
                                                {...field}
                                                h="96px"
                                                maxLength={99}
                                                paddingTop="30px"
                                                placeholder="Digite aqui..."
                                                isDisabled={isHistory}
                                                _placeholder={{ color: "gray.400" }}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    setObservationText(e.target.value);
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.observation && (
                                        <Text color="red.500" fontSize="sm">
                                            {errors.observation.message}
                                        </Text>
                                    )}
                                </Flex>
                            </Flex>
                            <Divider />
                            {organizateRateReviewPixOld && organizateRateReviewPixNew &&
                                <SectionReviewModal
                                    oldValue={organizateRateReviewPixOld}
                                    newValue={organizateRateReviewPixNew}
                                    nameSection="PIX"
                                />
                            }
                            <Divider />
                            {organizateRateReviewBankSlipOld && organizateRateReviewBankSlipNew &&
                                <SectionReviewModal
                                    oldValue={organizateRateReviewBankSlipOld}
                                    newValue={organizateRateReviewBankSlipNew}
                                    nameSection="Boleto"
                                />
                            }

                            <Divider />
                            {/* Cartão */}
                            {organizateRateReviewCreditCardOld && organizateRateReviewCreditCardNew &&
                                <Flex flexDir="column" gap="26px" >
                                    <SectionCreditCardReviewModal
                                        oldValue={organizateRateReviewCreditCardOld}
                                        newValue={organizateRateReviewCreditCardNew}
                                        nameSection="Crédito"

                                    />
                                    {(creditCardNewRates && creditCardOldRates) &&
                                        <Box>{renderComparisonTables()}</Box>
                                    }
                                </Flex>
                            }
                        </Flex>
                    </ModalBody>
                    {isHistory ?
                        <ModalFooter
                            display={"flex"}
                            w="100%"
                            justifyContent={"space-between"}
                        >
                            <Button variant="ghost" onClick={onClose} isDisabled={Loading} >
                                Fechar
                            </Button>

                        </ModalFooter> :
                        <ModalFooter
                            display={"flex"}
                            w="100%"
                            justifyContent={"space-between"}
                        >
                            <Button variant="ghost" onClick={onClose} isDisabled={Loading} >
                                Voltar para edição
                            </Button>

                            <Button variant="ghost" onClick={onClose} isDisabled={Loading} >
                                Voltar para edição
                            </Button>
                            <Button colorScheme="blue" mr={3} onClick={handleSubmit(onSubmit)} isLoading={Loading} isDisabled={Loading}>
                                Confirmar
                            </Button>

                        </ModalFooter>
                    }
                </ModalContent>
            </Modal>
        </Flex>
    );
}
